<template>
  <v-card class="app-card radius-always d-flex event-item my-1" :to="{ name: $routes.EVENT, params: { id: event.id } }">
    <event-thumbnail :event="event" />
    <div class="d-flex flex-column justify-center py-2 px-3">
      <div class="title-container truncate-multiline-2 font-weight-bold font-size-big" :class="{ 'font-size-title-small': $vuetify.display.mobile }" dir="auto">
        {{ event.title }}
      </div>
      <div class="font-size-medium my-1">{{ dateComputed }}</div>
      <event-rsvp-list v-if="event.rsvpMeta" :event="event" />
    </div>
  </v-card>
</template>

<script>
import EventThumbnail from "@/components/events/EventThumbnail.vue"
import EventRsvpList from "@/components/events/EventRsvpList.vue"

import * as dates from "@/services/dates"

export default {
  components: {
    EventThumbnail,
    EventRsvpList
  },
  props: {
    event: {
      type: Object,
      required: true
    }
  },
  computed: {
    absoluteDateTime() {
      return this.event.at.slice(0, 26)
    },
    dateComputed() {
      if (this.event.online_only) {
        return dates.getFormattedDate(this.event.at, { year: undefined, weekday: undefined, month: "long" })
      }
      return dates.getFormattedDate(`${this.absoluteDateTime}Z`, { year: undefined, timeZone: "UTC", weekday: undefined, month: "long" })
    }
  }
}
</script>

<style lang="scss" scoped>
.event-item {
  width: 260px;
  height: 126px;

  .title-container {
    line-height: 1.1;
  }

  :deep(.event-thumbnail) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
}
</style>
